import { BORDER_COLORS, ROOT_TOKENS_COLORS, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import { HEADING_XXS_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const TabContentWrapper = styled.div<{ $hasData: boolean }>`
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: ${ROOT_TOKENS_COLORS.white.default};

    border: ${({ $hasData }) => ($hasData ? `1px solid ${BORDER_COLORS.primary}` : 'none')};
    padding: ${({ $hasData }) => ($hasData ? '24px' : '0')};
`;

export const TabContentContainer = styled.div<{ $isBigScreen: boolean; $hidePagination?: boolean }>`
    width: ${({ $isBigScreen }) => ($isBigScreen ? '50rem' : '100%')};
    ${({ $hidePagination }) => $hidePagination && 'margin-bottom: 24px'};
`;

export const TabContentInfoWrapper = styled.div<{ $marginBottom?: number }>`
    display: flex;
    flex-direction: column;

    ${({ $marginBottom = 24 }) => `margin-bottom: ${$marginBottom}px;`}
`;

export const TabContentInfoHeader = styled.div`
    color: ${TC.body};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].lineHeight};
    ${DESKTOP_SIZES[SIZES.HEADING_XXS].fontWeight};
`;

export const TabContentInfoSubheader = styled.div`
    color: var(--colors-text-headings, #3e445c);
    ${HEADING_XXS_STYLES};
`;

export const TabContentInfoText = styled.div`
    color: ${TC.heading};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_MD_MED].fontWeight};
`;

export const FallbackAvatarWrapper = styled.div`
    svg {
        width: 36px;
        height: 36px;
    }
`;
